define(() => {
    const ETW_IS_READY = "ETWIsReady";

    return {
        ETW_IS_READY
    };
});



// WEBPACK FOOTER //
// ./src/editor/ui/experience/widgets/textEnhancedWidget/textWidgetEvents.js